
import React from 'react';

interface MetricValueProps {
  value: string | number;
  title: React.ReactNode;
  textColorClass?: string;
  noData?: boolean;
}

const MetricValue: React.FC<MetricValueProps> = ({ 
  value, 
  title, 
  textColorClass = '',
  noData = false
}) => {
  const formatValue = (val: string | number): string => {
    if (noData) {
      return "-";
    }
    
    if (typeof val === 'string') {
      // If it's already a string (like "$1,000"), return it as is
      return val;
    } else {
      // Format numbers without decimal places
      return val.toLocaleString('en-US', {
        maximumFractionDigits: 0
      });
    }
  };

  return (
    <div className="flex-1 flex flex-col justify-center items-center my-2">
      <div className={`text-2xl font-semibold mb-1 text-center ${textColorClass}`}>
        <span>{formatValue(value)}</span>
      </div>
      <div className={`text-sm mb-1 text-center ${textColorClass || 'text-gray-600'}`}>
        {title}
      </div>
    </div>
  );
};

export default MetricValue;
